import { map } from 'ramda'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Button } from '@/components/button'
import { Input } from '@/components/form'
import { H4, ParagraphRegular } from '@/components/text'
import { createModal, useModalize } from '@/components/modalize/mui'
import { breakpoints, colors } from '@/styles'

const Wrapper = styled.div`
  padding: 60px 32px 40px;
  text-align: center;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 60px 20px 40px;
  }
`

const Title = styled(H4)`
  color: ${colors.regular};
  text-align: center;
  margin-bottom: 40px;
`

const Text = styled(ParagraphRegular)`
  color: ${colors.grey16};
  margin: 32px 0 12px;
  text-align: left;
`

const Provider = styled(Text)`
  margin: 0;
`

const AddButton = styled(Button)`
  margin: 32px auto 0;
  width: 100%;
`

const AddLinkModal = ({ supportedProviders = [], onAddLink, title, providersMessage }) => {
  const { t } = useTranslation()
  const { close } = useModalize()

  const [url, setUrl] = useState('')

  const onAdd = async () => {
    const success = await onAddLink(url)
    if (success) close()
  }

  return (
    <Wrapper>
      <Title>{title}</Title>
      <Input
        name="url"
        id="url"
        value={url}
        type="text"
        onChange={e => setUrl(e.target.value)}
        placeholder={t('l.listing.edit.video_url.label', 'Video URL')}
      />
      <Text>{providersMessage}:</Text>
      {map(
        provider => (
          <Provider>• {provider}</Provider>
        ),
        supportedProviders
      )}
      <AddButton theme="primary" onClick={onAdd} disabled={url.length < 3}>
        {t('common.add', 'Add')}
      </AddButton>
    </Wrapper>
  )
}

export const show = createModal(AddLinkModal, {
  width: '550px'
})
